import { API_ENDPOINT, useJwtToken } from 'helper';
import { useQuery } from 'react-query';

export const pushFirmwareSideload = async (
    Thing_ID,
    downloadUrl,
    accessToken
) => {
    const url = new URL(`${API_ENDPOINT}/firmware/sideload`);
    const response = await fetch(url.toString(), {
        method: 'POST',
        headers: {
            Authorization: accessToken,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Thing_ID, downloadUrl }),
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(`Error status: ${response.status} - ${error.message}`);
    }
    return await response.json();
};

export const useAllFirmwarePackages = () => {
    const accessToken = useJwtToken();
    return useQuery(
        ['allFirmwarePackages'],
        () => fetchAllFirmwarePackages(accessToken),
        {
            enabled: !!accessToken,
            refetchOnReconnect: false,
        }
    );
};

const fetchAllFirmwarePackages = async (accessToken) => {
    const url = new URL(`${API_ENDPOINT}/firmware/sideload`);
    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
            Authorization: accessToken,
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};

export const getPresignedFirmwareUrl = async (s3Url, accessToken) => {
    const url = new URL(`${API_ENDPOINT}/firmware/presign`);
    url.searchParams.set('s3Url', s3Url);
    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
            Authorization: accessToken,
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.url;
};
